/* src/app/modules/user/partnersequity/reserve/reserve-delete.component.css */
/*# sourceMappingURL=reserve-delete.component.css.map */
